const actionScope = '[First Time Onboarding Completed]';

export class LoadIsOnboardingCompleted {
  static readonly type = `${actionScope} Load Is Onboarding Completed`;
}

export class LoadIsOnboardingCompletedIfNotLoaded {
  static readonly type = `${actionScope} Load Is Onboarding Completed If Not Loaded`;
}
